export default "assets/images/cloud-2-9a6c1c95.png";